import { render, staticRenderFns } from "./cadembalagens.vue?vue&type=template&id=808d8a54&"
import script from "./cadembalagens.vue?vue&type=script&lang=js&"
export * from "./cadembalagens.vue?vue&type=script&lang=js&"
import style0 from "./cadembalagens.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports